import { memo } from 'react';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useCrmSearchGraphQLViewSearch, useSearchRequestOptionsForView } from '../../hooks/tasksSearchResults';
import { ViewIdPropType } from '../../utils/propTypes';
import TaskViewTableV2 from './TaskViewTableV2';
import { jsx as _jsx } from "react/jsx-runtime";
function GraphQLViewTableInner({
  viewId,
  crmSearchQuery,
  searchKey
}) {
  const {
    loading,
    onRefreshSearch,
    onDelayedRefreshSearch
  } = useCrmSearchGraphQLViewSearch({
    crmSearchQuery,
    searchKey
  });
  return /*#__PURE__*/_jsx(TaskViewTableV2, {
    viewId: viewId,
    onRefreshSearch: onRefreshSearch,
    onDelayedRefreshSearch: onDelayedRefreshSearch,
    loading: loading
  });
}
function GraphQLViewTable({
  viewId
}) {
  // if crmSearchQuery is null then it hasn't been loaded from a view yet
  const {
    crmSearchQuery,
    searchKey
  } = useSearchRequestOptionsForView(viewId);
  if (!crmSearchQuery || !searchKey) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered"
    });
  }
  return /*#__PURE__*/_jsx(GraphQLViewTableInner, {
    crmSearchQuery: crmSearchQuery,
    searchKey: searchKey,
    viewId: viewId
  });
}
GraphQLViewTable.propTypes = {
  viewId: ViewIdPropType.isRequired
};
export default /*#__PURE__*/memo(GraphQLViewTable);